import React from 'react';
import './AboutUsPage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faUsers, faLightbulb, faHandshake, faPencilRuler } from '@fortawesome/free-solid-svg-icons';

const AboutUsPage = () => {
  return (
    <>
      <div className='back-img'>
        <div className="top-arch">
          <div className="button-container">
            <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
            <button className="call-for-action-button">
              AboutUs <FontAwesomeIcon icon={faArrowUp} className="arrow" />
            </button></a>
          </div>
        </div>
        <div className="about-us-page">
          <div className="text-container">
            <p className="about-text">
              We offer a comprehensive range of construction and design services to meet your needs.
          Whether you're looking to build a new home, renovate an existing space, or create a stunning commercial building,
          our team of experts is here to help.
            </p>
          </div>

          <div className="icon-grid">
            <div className="icon-item">
              <div className="icon">
                <FontAwesomeIcon icon={faUsers} />
              </div>
              <p className="icon-text">Our Team</p>
            </div>
            <div className="icon-item">
              <div className="icon">
                <FontAwesomeIcon icon={faLightbulb} />
              </div>
              <p className="icon-text">Innovation</p>
            </div>
            <div className="icon-item">
              <div className="icon">
                <FontAwesomeIcon icon={faHandshake} />
              </div>
              <p className="icon-text">Client Focus</p>
            </div>
            <div className="icon-item">
              <div className="icon">
                <FontAwesomeIcon icon={faPencilRuler} />
              </div>
              <p className="icon-text">Design Excellence</p>
            </div>
          </div>
        </div>
        <div className="bottom-arch"></div>
      </div>
    </>
  );
};

export default AboutUsPage;